import './Navigation.css';
export var button = '_z3330k2-2-0-1';
export var inlineNav = '_z3330k4-2-0-1';
export var isDisabled = '_z3330k1-2-0-1';
export var isSelected = '_z3330k0-2-0-1';
export var menuLink = '_z3330k3-2-0-1';